<template>
  <div class="show loader-container">
    <v-runtime-template :template="show.templateFull || template"></v-runtime-template>

    <div v-if="performances.length > 0" class="performances">
      <Performance
        v-for="performance in performances"
        :key="performance.id"
        :performance="performance"
        :performance-id="performanceId"
        :product-id="productId"
      />
    </div>
    <div v-if="showProducts.length > 0" class="products">
      <b-tabs nav-class="product-name" content-class="product" justified pills>
        <b-tab
          v-for="product in showProducts"
          :key="product.id"
          :title="product.name"
          :active="productId == product.id"
          class="product"
        >
          <Product :product="product"></Product>
        </b-tab>
      </b-tabs>
    </div>
    <Loader :loading="loadingShow || loadingPerformances || loadingProducts" />
  </div>
</template>
<script>
import Service from '@/services/Service.js';
import Performance from '@/components/Performance.vue';
import Product from '@/components/Product.vue';
import ImageDisplay from '@/components/ImageDisplay.vue';
import Loader from '@/components/Loader.vue';
import VRuntimeTemplate from 'v-runtime-template';

export default {
  components: { Performance, Product, ImageDisplay, Loader, VRuntimeTemplate },
  props: {
    showId: { type: String, default: null },
    performanceId: { type: String, default: null },
    productId: { type: String, default: null }
  },
  data: function() {
    return {
      show: {},
      performances: [],
      showProducts: [],
      loadingShow: false,
      loadingPerformances: false,
      loadingProducts: false,
      template: `<div class="show-details">
      <div class="show-genre">{{show.genre}}</div>
      <h1>{{ show.name }}</h1>
      <div class="show-dates">
          {{ show.startDate | formatDate }}
          <template v-if="show.endDate && show.endDate != show.startDate">- {{ show.endDate | formatDate }}</template>
      </div>
      <div class="show-space">{{show.space}}<template v-if="show.space && show.venue">, </template>{{show.venue}}</div>
      <div class="web-copy" v-html="show.webCopy"></div>
      <ImageDisplay :image="show.image" :height="200" :width="250" /></div>`
    };
  },
  created() {
    this.loadingShow = true;
    this.loadingPerformances = true;
    this.loadingProducts = true;
    Service.getShow(this.showId).then(response => {
      this.show = response.data;
      this.loadingShow = false;
    });
    Service.getPerformances(this.showId).then(response => {
      this.performances = response.data;
      this.loadingPerformances = false;
    });
    Service.getShowProducts(this.showId).then(response => {
      this.showProducts = response.data;
      this.loadingProducts = false;
    });
  }
};
</script>
